export * from './lib/shared-feature-department-types';
